import { useMutation, useQueryClient } from "@tanstack/react-query";
import { doc, updateDoc } from "firebase/firestore";
import { db } from "@/config/firebaseConfig";

export default function useUpdateTopLevelReciprocalMatch() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ id, fields }: any) => {
      try {
        await updateDoc(doc(db, `TopLevelReciprocalMatches`, id), fields);
      } catch (error) {
        console.error(error);
      }
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["TopLevelReciprocalMatches"],
      });
    },
  });
}
